import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper';

import { MockToolCard } from '../MockToolCard';

const mockArr = ['', '', '', '', '', '', '', '', ''];
type Props = {
  title: string;
  showSwiper?: boolean;
};

const SkeletonPage = ({ showSwiper, title }: Props) => (
  <>
    {showSwiper && (
      <div className='pb-5 border-t-2 px-6 xs:px-4'>
        <div className='max-w-[770px] mx-auto pt-6 pb-4 '>
          <h2 className='text-lg leading-xl font-bold'>This week update</h2>
        </div>
        <Swiper
          modules={[FreeMode]}
          slidesPerView='auto'
          spaceBetween={12}
          centerInsufficientSlides
          breakpoints={{ 480: { spaceBetween: 20 } }}
        >
          {mockArr.map(() => (
            <SwiperSlide className='w-[204px] sm:w-[180px] xs:w-[170px]' key={Math.random()}>
              <MockToolCard size='small' />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    )}
    <div className='border-t-2 w-auto'>
      <div className='mx-auto w-max p-6 xs:p-4 xxs:mx-0 xxs:w-full'>
        <h2 className='text-lg leading-xl font-bold mb-4'>All {title}</h2>
        <ul className='grid xxs:grid-cols-1 gap-5 md:grid-cols-2 grid-cols-3 w-max xs:gap-3 xxs:mx-auto'>
          {mockArr.map(() => (
            <li key={Math.random()}>
              <MockToolCard size='large' />
            </li>
          ))}
        </ul>
      </div>
    </div>
  </>
);

export { SkeletonPage };
